import RegisterInstructionsScreen from './register-instructions-screen';

export default RegisterInstructionsScreen;
